<p-colorPicker [ngModel]="_value" (ngModelChange)="colorChanged($event)"></p-colorPicker>
<input pInputText class="hex-input" [ngModel]="_value" (ngModelChange)="hexChanged($event)">
